import { HttpClient, HttpEvent, HttpEventType } from "@angular/common/http";
import { Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { File, FileEntry } from '@ionic-native/file';
import { FileChooser } from '@ionic-native/file-chooser';
import { FileOpener } from '@ionic-native/file-opener';
import { FilePath } from "@ionic-native/file-path";
import { FileTransfer } from '@ionic-native/file-transfer';
import { TranslateService } from "@ngx-translate/core";
import * as async from 'async';
import { Platform } from "ionic-angular";
import { FileTransferHttpOptions, FileTransferNative } from "../../native/file-transfer.native";
import { AppPreferences } from "../../shared/local/app-preferences.local";
import { FormDataUpload } from "../../shared/nestjs/nest-api";
import { GlobalServiceProvider } from "../global-service/global-service";
@Injectable()
export class FileUploaderProvider {
  private renderer: Renderer2;
  public modal: any = null;
  public fillElement: any;
  public textElement: any;
  public timeout: any;
  public percentageProgress = 0;
  public countDefaultProgress: number = 0;

  constructor(
    public FileOpener: FileOpener,
    public trasfer: FileTransfer,
    public file: File,
    public fileChooser: FileChooser,
    public appPreferences: AppPreferences,
    public http: HttpClient,
    public platform: Platform,
    public globalServiceProvider: GlobalServiceProvider,
    public filePath: FilePath,
    public fileTransferNative: FileTransferNative,
    public translate: TranslateService,
    public rendererFactory: RendererFactory2,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  processFile(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.fileChooser.open().then(url => {
        const originalName = url.substring(url.lastIndexOf('/') + 1);
        this.file.resolveLocalFilesystemUrl(url)
          .then(entry => (<FileEntry>entry).file(async file => {
            const blob = await this.readFile(file);
            resolve({ blob, originalName });
          }))
          .catch(err => {
            console.log(err);
            reject(err);
          }
          )
      });
    })
  }

  readFile(file: any): Promise<any> {
    return new Promise<any>(resolve => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imgBlob = new Blob([reader.result], { type: file.type });
        resolve(imgBlob);
      };
      reader.readAsArrayBuffer(file);
    })
  }

  processFileFromUri(imageFileUri: any): Promise<any> { // get blob
    return new Promise<any>((resolve, reject) => {
      console.log(imageFileUri);
      this.file.resolveLocalFilesystemUrl(imageFileUri)
        .then(entry => (<FileEntry>entry).file(async file => {
          const blob = await this.readFile(file);
          resolve(blob);
        }))
        .catch(err => {
          console.log('babay ganteng', err);
          reject(err);
        }
        );
    })
  }

  resolvePathNative(type: 'image' | 'file', pathUri: string) {
    return new Promise(async (resolve, reject) => {
      try {
        let files = '';
        if (type != 'image') {
          /** type file */
          if (this.platform.is('android')) {
            const filePath = await this.filePath.resolveNativePath(pathUri);
            files = await this.processFileFromUri(filePath);
          } else {
            files = await this.processFileFromUri(`file:///${pathUri}`);
          }
        } else {
          /** type image */
          files = await this.processFileFromUri(pathUri);
        }
        resolve(files);
      } catch (error) {
        reject(error);
      }
    })
  }

  uploadMultipleWithHttp(options: OptionsUploadWithHttp, urlUpload: string) {
    return new Promise<string[]>((resolve, reject) => {
      let files = [];
      async.eachOfSeries(options.nativeURI, async (item, index, callback) => {
        options.nativeURI = item;
        const fileName = await this.uploadWithHttp(options, urlUpload);
        files.push(fileName);
        callback();
      }, error => {
        if (error) reject(error);
        resolve(files);
      })
    })
  }

  /**
   * @param item
   * @param urlUpload
   * @param customResponse default true, true => standarisasi response dari server,  false => return semua response dari server
   */
  uploadWithHttp(item: OptionsUploadWithHttp, urlUpload: string, customResponse: boolean = true, customFileName?: string) {
    return new Promise<any>(async (resolve, reject) => {
      let bodies: FormDataUpload[] = [];
      let body: FormDataUpload;
      let files = null;

      if (!item.name) {
        item.name = 'file';
      }

      try {
        /** upload from native source */
        if (this.platform.is('cordova')) {
          let fileName = '';
          if (item.nativeURI instanceof Blob) {
            files = item.nativeURI;
            fileName = item.options;
          } else {
            const getFilePath = this.globalServiceProvider.getFilePath(item.nativeURI);
            fileName = customFileName ? customFileName : getFilePath.filename;
            files = await this.resolvePathNative(item.type, item.nativeURI);
          }

          body = { name: item.name, value: files, fileName: fileName };
        }
        else {
          /** upload from web source*/
          files = item.eventsWebview[0] ? item.eventsWebview[0] : item.eventsWebview;
          body = { name: item.name, value: files, fileName: item.options }
        }

        if (item.body) {
          for (let key in item.body) {
            bodies.push({ name: key, value: item.body[key] })
          }
        }

        bodies.push(body);
        const options: FileTransferHttpOptions = {
          url: urlUpload,
          method: 'POST',
          body: bodies
        }

        this.fileTransferNative.uploadHttp(options)
          .subscribe((event: HttpEvent<any>) => {
            if (event.type === HttpEventType.UploadProgress) {
              this.percentageProgress = Math.round(100 * event.loaded / event.total);
              // console.log(`File is ${this.percentageProgress}% uploaded.`);
            } else if (event.type === HttpEventType.Response) {
              const body = event.body;
              let result = body;
              if (customResponse) {
                if (body.hasOwnProperty('data') && body.data) {
                  if (body.data instanceof Array) {
                    console.log('masuk sini', body.data instanceof Array)
                    result = body.data.length > 0 ? body.data[0].fileName : null;
                  }
                  else {
                    result = body.data.fileName;
                  }
                }
                else {
                  result = body.result.files.file[0].name;
                }
              }

              resolve(result);
            }
          }, error => {
            reject(error);
          });
      }
      catch (error) {
        reject(error);
      }
    });
  }


  uploadWithHttpCustom(item: OptionsUploadWithHttp, urlUpload: string) {
    return new Promise<any>(async (resolve, reject) => {
      let bodies: FormDataUpload[] = [];
      let body: FormDataUpload;
      let files = null;

      if (!item.name) {
        item.name = 'file';
      }

      try {
        /** upload from native source */
        if (this.platform.is('cordova')) {
          const getFilePath = this.globalServiceProvider.getFilePath(item.nativeURI);
          const fileName = getFilePath.filename;

          files = await this.resolvePathNative(item.type, item.nativeURI);
          body = { name: item.name, value: files, fileName: fileName };
        }
        else {
          /** upload from web source*/
          files = item.eventsWebview[0] ? item.eventsWebview[0] : item.eventsWebview;
          body = { name: item.name, value: files, fileName: item.options }
        }

        if (item.body) {
          for (let key in item.body) {
            bodies.push({ name: key, value: item.body[key] })
          }
        }

        bodies.push(body);
        const options: FileTransferHttpOptions = {
          url: urlUpload,
          method: 'POST',
          body: bodies
        }

        this.fileTransferNative.uploadHttp(options)
          .subscribe((event: HttpEvent<any>) => {
            if (event.type === HttpEventType.UploadProgress) {
              this.percentageProgress = Math.round(100 * event.loaded / event.total);
              console.log(`File is ${this.percentageProgress}% uploaded.`);
            } else if (event.type === HttpEventType.Response) {
              const body = event.body;
              let result = body.data;
              resolve(result);
            }
          }, error => {
            reject(error);
          });
      }
      catch (error) {
        reject(error);
      }
    });
  }

  // #region Custom Loading Progress
  createCustomProgress() {
    this.modal = this.renderer.createElement('div');
    let parrent = this.renderer.createElement('div');
    this.textElement = this.renderer.createElement('p');
    let progressArea = this.renderer.createElement('div');
    let lineDownload = this.renderer.createElement('div');
    this.fillElement = this.renderer.createElement('div');
    this.renderer.addClass(parrent, 'download-section');
    this.renderer.addClass(this.textElement, 'download-text');
    this.renderer.addClass(progressArea, 'download-progress');
    this.renderer.addClass(lineDownload, 'download-line');
    this.renderer.addClass(this.fillElement, 'download-fill');
    this.renderer.addClass(this.modal, 'overlay-custom');


    this.renderer.appendChild(parrent, this.textElement);
    this.renderer.appendChild(lineDownload, this.fillElement);
    this.renderer.appendChild(progressArea, lineDownload);
    this.renderer.appendChild(parrent, progressArea);
    this.renderer.appendChild(this.modal, parrent);
    this.textElement.innerText = this.translate.instant('Uploading') + "(0%)";
    this.renderer.appendChild(document.getElementsByTagName("ion-app")[0], this.modal);
  }

  loadingProgress(value) {
    this.temporaryProgress();
    if (this.fillElement) {
      this.renderer.setStyle(this.fillElement, 'width', (isNaN(value) ? this.countDefaultProgress : value) + "%");
    }
    if (this.textElement) {
      this.textElement.innerText = this.translate.instant('Uploading') + "(" + (isNaN(value) ? this.countDefaultProgress : value) + "%)";
    }
  }

  temporaryProgress() {
    if (this.countDefaultProgress >= 90) {
      setTimeout(() => {
        if (this.countDefaultProgress <= 98) {
          this.countDefaultProgress++;
        } else {
          this.countDefaultProgress = 99;
        }
      }, 1000);
    } else {
      this.countDefaultProgress += 15;
    }
  }


  removeCustomProgress() {
    this.countDefaultProgress = 100;
    // reset
    setTimeout(() => {
      this.countDefaultProgress = 0;
    }, 1000);

    if (this.modal) {
      this.timeout = setTimeout(() => {
        let blocks = document.getElementsByTagName("ion-app")[0].querySelectorAll(".overlay-custom");
        for (let i = 0; i < blocks.length; i++) {
          this.renderer.removeChild(document.getElementsByTagName("ion-app")[0], blocks[i]);
        }
        this.modal = null;
        this.fillElement = null;
        clearTimeout(this.timeout);
      }, 1000);
    }
  }


  /**
    * COPY FILE
    * @param localPath 
    * @param fileName 
    * @param newPath 
    */
  copyFile(localPath, fileName, newPath) {
    return new Promise(resolve => {
      this.file.copyFile(localPath, fileName, newPath, fileName)
        .then(res => {
          console.log('success copy file', res);
          resolve(true);
        })
        .catch(error => {
          console.log('error copy file', error)
          resolve(false);
        });
    })
  }
}

export interface OptionsUploadWithHttp {
  options: any, // filename exp. 12412948120412.jpg
  nativeURI: any, // uri from native source
  type: 'image' | 'file', // image or file
  eventsWebview: any // blob from web source,
  body?: any; // exp: {key: value}
  name?: string,
  userid?: any,
}




// WEBPACK FOOTER //
// ./src/providers/file-uploader/file-uploader.ts